import { isMock } from '../config'
import { withOfflineCache } from '../offline-cache'
import { guiaMock } from './mock'
import { guiaReal } from './real'
import type { GuiaService } from './types'

const impl: GuiaService = isMock('guia') ? guiaMock : guiaReal

/** La guía sigue disponible sin conexión (8.7; DESIGN.md §7; D18), con el mismo mecanismo que Accesos (bloque 4). */
export const guiaService: GuiaService = {
  getGuide: (stay, signal) => withOfflineCache(stay.guestCode, 'guide', () => impl.getGuide(stay, signal)),
}
export { guideFromStay } from './real'
export type { Guide, GuideSection, GuideStay, GuiaService, NearbyCategory, NearbyPlace } from './types'
